import { render, staticRenderFns } from "./SocialImage.vue?vue&type=template&id=4c11eea2&scoped=true&functional=true&"
import script from "./SocialImage.vue?vue&type=script&lang=js&"
export * from "./SocialImage.vue?vue&type=script&lang=js&"
import style0 from "./SocialImage.vue?vue&type=style&index=0&id=4c11eea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4c11eea2",
  null
  
)

export default component.exports